export const EMPTY_MISSING_PROVIDER_KEY_SET: ReadonlySet<string> = new Set()
export const EMPTY_PHASE_VALIDATION_KEY_SET: ReadonlySet<string> = new Set()
export const TX_PLAN_HISTORY_MAX_SNAPSHOTS = 10
